export var GRPC_HOSTNAME = 'studio.inworld.ai';
export var CLIENT_ID = 'web';
export var DEFAULT_USER_NAME = 'User';
export var SCENE_PATTERN = /^workspaces\/([a-z0-9-_]{1,61})\/(characters|scenes)\/([a-z0-9-_]{0,61})$/iu;
